/**
 * WhatsApp buy button (product page).
 *
 * Keeps the button's WhatsApp link accurate at the moment it is clicked,
 * reflecting whichever variant and quantity the customer currently has
 * selected — including the correct national shipping cost (or "Gratis"
 * once the order reaches the free-shipping threshold), computed the same
 * way the checkout would. It only reads data Dawn already keeps up to date
 * elsewhere (the variant-selects JSON, the rendered price, the quantity
 * input) — it does not modify any of that existing behavior.
 */
(function () {
  // Standard Shopify money formatter: turns cents + a money_format string
  // (e.g. "${{amount_no_decimals_with_comma_separator}}") into the same
  // text the store's own price tags already show, so amounts computed here
  // (shipping, totals) match the store's currency formatting exactly.
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || '${{amount}}';

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = typeof precision === 'undefined' ? 2 : precision;
      thousands = typeof thousands === 'undefined' ? ',' : thousands;
      decimal = typeof decimal === 'undefined' ? '.' : decimal;

      if (isNaN(number) || number === null) return 0;

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands);
      var centsPart = parts[1] ? decimal + parts[1] : '';

      return dollars + centsPart;
    }

    var match = formatString.match(placeholderRegex);
    var placeholder = match ? match[1] : 'amount';

    switch (placeholder) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 2, "'", '.');
        break;
      default:
        value = formatWithDelimiters(cents, 2);
    }

    return formatString.replace(placeholderRegex, value);
  }

  function getSelectedVariant(button) {
    var scope = button.closest('.product, product-info') || document;
    var script = scope.querySelector('variant-selects [data-selected-variant]');
    if (!script) return null;
    try {
      return JSON.parse(script.textContent);
    } catch (error) {
      return null;
    }
  }

  function getQuantity(button) {
    var scope = button.closest('.product, product-info') || document;
    var input = scope.querySelector('.quantity__input');
    var value = input ? parseInt(input.value, 10) : 1;
    return value > 0 ? value : 1;
  }

  function getDisplayedPrice(button) {
    var sectionId = button.id.replace('WhatsappBuyButton-', '');
    var priceWrapper = document.getElementById('price-' + sectionId);
    if (priceWrapper) {
      var saleEl = priceWrapper.querySelector('.price-item--sale');
      if (saleEl && saleEl.offsetParent !== null) return saleEl.textContent.trim();
      var regularEl = priceWrapper.querySelector('.price-item--regular');
      if (regularEl && regularEl.offsetParent !== null) return regularEl.textContent.trim();
    }
    return button.dataset.initialPrice || '';
  }

  function updateHref(button) {
    var variant = getSelectedVariant(button);
    var quantity = getQuantity(button);
    var price = getDisplayedPrice(button);
    var variantTitle = variant && variant.title && variant.title !== 'Default Title' ? variant.title : '';

    var unitPriceCents =
      variant && typeof variant.price === 'number' ? variant.price : parseInt(button.dataset.unitPriceCents, 10) || 0;
    var lineTotalCents = unitPriceCents * quantity;

    var thresholdCents = parseInt(button.dataset.shippingThresholdCents, 10) || 0;
    var shippingCostCents = parseInt(button.dataset.shippingCostCents, 10) || 0;
    var shippingCents = lineTotalCents >= thresholdCents ? 0 : shippingCostCents;
    var grandTotalCents = lineTotalCents + shippingCents;

    var moneyFormat =
      button.dataset.currencyCodeEnabled === 'true' ? button.dataset.moneyWithCurrencyFormat : button.dataset.moneyFormat;

    var subtotalText = formatMoney(lineTotalCents, moneyFormat);
    var shippingText = shippingCents === 0 ? 'Gratis' : formatMoney(shippingCents, moneyFormat);
    var totalText = formatMoney(grandTotalCents, moneyFormat);

    var url = button.dataset.rootUrl;
    if (variant && variant.id) {
      url += 'cart/' + variant.id + ':' + quantity;
    }

    var message = button.dataset.template
      .split('{{product}}').join(button.dataset.productTitle)
      .split('{{variant}}').join(variantTitle)
      .split('{{color}}').join(button.dataset.colorLine || '')
      .split('{{quantity}}').join(String(quantity))
      .split('{{price}}').join(price)
      .split('{{subtotal}}').join(subtotalText)
      .split('{{shipping}}').join(shippingText)
      .split('{{total}}').join(totalText)
      .split('{{url}}').join(url);

    button.setAttribute('href', 'https://wa.me/' + button.dataset.number + '?text=' + encodeURIComponent(message));

    if (variant && variant.available === false) {
      button.setAttribute('disabled', 'disabled');
    } else {
      button.removeAttribute('disabled');
    }
  }

  function init() {
    document.querySelectorAll('[data-whatsapp-buy-button]').forEach(function (button) {
      if (button.dataset.whatsappInitialized) return;
      button.dataset.whatsappInitialized = 'true';
      button.addEventListener('click', function (event) {
        if (button.hasAttribute('disabled')) {
          event.preventDefault();
          return;
        }
        updateHref(button);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-scan if the theme editor injects a new instance of this block
  // (e.g. when Matt adds/reorders it while customizing the theme).
  document.addEventListener('shopify:section:load', init);
})();